import * as React from "react";

import styles from "./ColumnHeaderLabel.module.css";

export interface ColumnHeaderLabelSortMeta {
  field: string;
  order: number;
}

export interface ColumnHeaderLabelProps {
  label: string;
  sortable?: boolean;
  field?: string;
  multiSortMeta?: ColumnHeaderLabelSortMeta[];
}

export const ColumnHeaderLabel: React.FC<ColumnHeaderLabelProps> = ({ label, sortable = true, field, multiSortMeta }) => {
  const activeMeta = multiSortMeta?.find((m) => m.field === field);
  const sortIcon = !activeMeta
    ? `fa-solid fa-sort`
    : activeMeta.order === 1
      ? `fa-solid fa-sort-up`
      : `fa-solid fa-sort-down`;

  return (
    <span className={styles[`header-label`]}>
      {label}
      {sortable && (
        <i
          className={`${sortIcon} ${styles[`sort-icon`]} ${activeMeta ? styles[`sort-icon-active`] : ``}`}
          aria-hidden="true" />
      )}
    </span>
  );
};
